import { useEffect, useRef } from "react";
import { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import { useLoadMessages } from "./useLoadMessages";
import { useMessageSubscription } from "./useMessageSubscription";
import { useSendMessage } from "./useSendMessage";

export function useMessages(user: User | null, conversationId: string | null) {
  const { messages, setMessages, loadMessages } = useLoadMessages(conversationId);
  const { setupRealtimeSubscription } = useMessageSubscription(
    conversationId,
    (newMessage) => setMessages((current) => [...current, newMessage])
  );
  const { isLoading, sendMessage: sendMessageToServer } = useSendMessage(user);
  const channelRef = useRef<ReturnType<typeof setupRealtimeSubscription>>(null);

  useEffect(() => {
    if (conversationId) {
      loadMessages(conversationId);
    } else {
      setMessages([]);
    }
  }, [conversationId]);

  useEffect(() => {
    if (conversationId) {
      // Store the channel reference
      channelRef.current = setupRealtimeSubscription();

      return () => {
        console.log('Cleaning up realtime subscription');
        if (channelRef.current) {
          supabase.removeChannel(channelRef.current);
          channelRef.current = null;
        }
      };
    }
  }, [conversationId]);

  const sendMessage = async (message: string) => {
    await sendMessageToServer(message, conversationId, messages);
  };

  return {
    messages,
    isLoading,
    sendMessage,
  };
}